(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root === '/' || typeof window.fetch !== 'function') return;

  var LOCALIZED = /^\/(products|collections|cart|search|recommendations)(\/|\.|\?|$)/;

  function localize(url) {
    if (typeof url !== 'string') return url;
    var path = url;
    var origin = '';
    if (url.indexOf(location.origin + '/') === 0) {
      origin = location.origin;
      path = url.slice(origin.length);
    }
    if (path.charAt(0) !== '/' || path.indexOf(root) === 0 || !LOCALIZED.test(path)) return url;
    return origin + root + path.slice(1);
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    if (typeof input === 'string') {
      input = localize(input);
    } else if (input && typeof input.url === 'string' && typeof Request === 'function' && input instanceof Request) {
      var localized = localize(input.url);
      if (localized !== input.url) input = new Request(localized, input);
    }
    return nativeFetch.call(this, input, init);
  };
})();
